// extracted by mini-css-extract-plugin
export default {"mainFooter":"footer_mainFooter__HXoWt","text":"footer_text__pflRr","thsLogo":"footer_thsLogo__q2SgU"};